import { configureStore } from '@reduxjs/toolkit';
import headerReducer from '../features/headerSlice';
import inputReducer from '../features/inputSlice';

export const store = configureStore({
  reducer: {
    input: inputReducer,
    header: headerReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
